import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CreateTaskData, TaskViewService } from 'src/app/services/task.view.service';
import { JoiEvent } from 'src/app/store/events.era';
import { FilterGroupTypes, filterPageTypes } from 'src/app/store/filters.era';
import { EventMenuSelection, eventSelectionsReselector } from 'src/app/store/reselectors/events.reselector';
import { Wrapper } from '../wrapper.component';
import { CommandMenuComponent } from '../nav-bar/command-menu.component';

@Component({
    selector: 'tasks-command-menu',
    template: `
<command-menu
  [showDottedMenu]="true" 
  [canEditColumns]="isTableView"
  [showHideTasks]="true"
  [showDetailOptions]="!isCalendarView"
  [hideSearch]="isCalendarView"
  [filterPage]="filterPage" 
  [showExport]="true"
  [showImport]="showImport"
  [forceShowAddItem]="outsideEvent"
  (onExport)="saveTable.emit()"
  (onImport)="onImport.emit()"
  (addItem)="addTask($event)"
  filterText="Filter tasks" 
  [addItemText]="'+ ADD A TASK'"
></command-menu>
`,
    standalone: true,
    imports: [CommandMenuComponent],
})
export class TasksCommandMenu extends Wrapper<TasksCommandMenu> implements OnInit {
  @Input() filterPage: keyof FilterGroupTypes
  @Input() isTableView = false
  @Input() isCalendarView = false
  @Input() showImport = false
  @Input() outsideEvent = false
  @Input() canAddItem = true

  @Output() saveTable: EventEmitter<void> = new EventEmitter()
  @Output() onImport: EventEmitter<void> = new EventEmitter()

  eventSelections: EventMenuSelection[] = []
  event: JoiEvent

  filterPageTypes = filterPageTypes

  constructor(private taskViewService: TaskViewService) {
    super()
  }

  ngOnInit() {
    this.subProp(this.store.select('events', 'event'), 'event')
    if (this.outsideEvent) this.selectProp(eventSelectionsReselector, null, 'eventSelections')
  }

  async addTask (event: Event, dateId: string = null) {
    const rect = event && window.innerHeight / 2 - 80 > 50 ? (<HTMLElement>event.target).getBoundingClientRect() : null
    const data: CreateTaskData = { eventId: this.event ? this.event.eventId : null, dateId, dialog: this.dialog, eventSelections: this.outsideEvent ? this.eventSelections : null, rect }
    await this.taskViewService.addTaskThroughPopupDialog(data)
  }

}